<template>
  <div class="contentPage workSchedule">
    <div class="workScheduleTitle">Employee work schedule</div>
    <div class="workScheduleHead">
      <div class="workScheduleHead-tabs">
        <tab-block
          tab-text="name"
          :tab="tab"
          :tab-list="scheduleWeeks"
          @updateTab="onTab($event)"
        ></tab-block>
      </div>
      <div class="workScheduleHead-filter">
        <div class="fieldBody">
          <span>Week selection:</span>
          <field
            margin="0 40px 0 10px"
            padding="5px 10px"
            width="80px"
            placeholder=""
            @updateMultiSelect="onSelect($event, 'week')"
            :multiValue="week"
            :items="weekList"
            :is-clearable="false"
            text-value="value"
            is-multiple
          ></field>
        </div>
<!--        <div class="fieldBody">-->
<!--          <span>Employee:</span>-->
<!--          <field-->
<!--            margin="0 0 0 10px"-->
<!--            padding="5px 10px 10px 10px"-->
<!--            width="220px"-->
<!--            placeholder="Select employee"-->
<!--            @updateSelect="onSelect($event, 'employee')"-->
<!--            :autocompleteValue="employee"-->
<!--            :items="scheduleEmployees"-->
<!--            is-select-->
<!--          ></field>-->
<!--        </div>-->
        <div class="fieldBody">
          <span>Employee:</span>
	        <field
			        placeholder="Select Employee"
			        margin="0 0 0 10px"
			        padding="5px 10px 10px 10px"
			        width="220px"
			        :isMultiple="true"
			        :isBtnAll="true"
			        :items="scheduleEmployees"
			        :multiValue="employeeList"
			        item-text="value"
			        item-value="id"
			        @updateMultiSelect="onDepartmentsSelect"
	        ></field>
        </div>
      </div>
    </div>
    <preload v-if="isPreloader"></preload>
    <div v-else>
      <tab-block :tab="tab" :only-control-tabs="false">
        <v-tab-item>
          <employee-schedule
              :week="week"
              :currentDate="currentDate"
              :scheduleEmployeesList="scheduleEmployeesList"
              :employeeId="employee && employee.id"
              :employeeList="employeeList"
              @onHandlerPopup="onHandlerPopup($event, true)"
          ></employee-schedule>
        </v-tab-item>
        <v-tab-item>
          <employee-schedule
              :week="week"
              :currentDate="currentDate"
              :scheduleEmployeesList="scheduleEmployeesList"
              :employeeId="employee && employee.id"
              :employeeList="employeeList"
              @onHandlerPopup="onHandlerPopup($event, true)"
          ></employee-schedule>
        </v-tab-item>
        <v-tab-item>
          <employee-schedule
              :week="week"
              :currentDate="currentDate"
              :scheduleEmployeesList="scheduleEmployeesList"
              :employeeId="employee && employee.id"
              :employeeList="employeeList"
              @onHandlerPopup="onHandlerPopup($event, true)"
          ></employee-schedule>
        </v-tab-item>
      </tab-block>
    </div>
    <employee-work-schedule-popup
      v-if="isEmployeeWorkSchedulePopup"
      :editData="editData"
      :tab="tab"
      @updateClose="onHandlerPopup(null, false)"
    ></employee-work-schedule-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TabBlock from "@/shared/TabBlock/TabBlock";
import Preload from "@/shared/Preload/Preload";
import getDefaultDate from "@/helper/getDefaultDate";
import EmployeeSchedule from "@/components/Safety/EmployeeWorkSchedule/EmployeeSchedule/EmployeeSchedule";
const EmployeeWorkSchedulePopup = () =>
	import('@/components/Safety/EmployeeWorkSchedule/EmployeeWorkSchedulePopup/EmployeeWorkSchedulePopup');

export default {
	name: "EmployeeWorkSchedule",
	components: { Preload, TabBlock, EmployeeWorkSchedulePopup, EmployeeSchedule },
	computed: mapGetters([
		"scheduleWeeks",
		"scheduleEmployeesList",
		"scheduleEmployees"
	]),
	data: () => ({
		isPreloader: false,
		currentDate: null,
		editData: null,
		isEmployeeWorkSchedulePopup: false,
		employee: null,
		employeeList: [],
		week: [ { value: 1 } ],
		tab: 1,
		weekList: [ { value: 1 }, { value: 2 }, { value: 3 }, { value: 4 } ],
	}),
	methods: {
		...mapActions([ "getEmployeeWorkSchedule", "getEmployeeWorkScheduleTab", 'getScheduleEmployee', 'onScheduleEmployeeSave' ]),
		onAutocomplete({ value, idx }, key) {
			if (idx !== undefined) {
				this.exceptionList[idx][key] = value?.id ?? value;
				return false;
			}

			this[key] = value?.id ?? value;

		},
		onDepartmentsSelect({ value }) {
			this.employeeList = value || [];
		},
		onSelect({ value }, key) {
			if (key === "week") {
				this[key] = value.sort((a, b) => a.value - b.value);
			} else {
				this[key] = value;
			}
		},
		async onTab(value) {
			this.isPreloader = true;
			this.tab = value;
			const date = this.scheduleWeeks[value]["date_start"];
			await this.getEmployeeWorkScheduleTab(date);
			this.isPreloader = false;
		},
		async onHandlerPopup(value, isOpen) {
			this.editData = value;
			this.isEmployeeWorkSchedulePopup = isOpen;
		},
		getDefaultWeek() {
			this.currentDate = getDefaultDate();
			let int = 1;
			for (const key in this.scheduleEmployeesList) {
				const weeks = this.scheduleEmployeesList[key];
				for (const weekKey in weeks) {
					if (weekKey === this.currentDate) {
						this.week = [ { value: int } ];
					}
				}

				int++;
			}
		}
	},
	async created() {
		this.isPreloader = true;
		await this.getEmployeeWorkSchedule();
		this.isPreloader = false;
		this.getDefaultWeek();
	},
};
</script>

<style scoped lang="scss">
  @import "employeeWorkSchedule";
</style>
